import React from 'react'

const SupplierCreateNewProduct = () => {
  return (
    <div className='max-w-[1400px] mx-auto mt-3'>

      <div>
        <p className='text-3xl font-semibold'>
          Complete Your Listing
        </p>
      </div>

      <div className='p-3 mb-3 border-b-2'>
        <p className='text-2xl font-semibold'>
          Photos and Videos
        </p>
        <div className="flex items-center justify-center w-full border-2 border-dashed rounded-xl">
          <label for="dropzone-file" className="flex flex-col items-center justify-center w-full h-64 bg-neutral-secondary-medium border border-dashed border-default-strong rounded-base cursor-pointer hover:bg-rose-50 transition duration-200">
              <div className="flex flex-col items-center justify-center text-body pt-5 pb-6">
                  <svg className="w-8 h-8 mb-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h3a3 3 0 0 0 0-6h-.025a5.56 5.56 0 0 0 .025-.5A5.5 5.5 0 0 0 7.207 9.021C7.137 9.017 7.071 9 7 9a4 4 0 1 0 0 8h2.167M12 19v-9m0 0-2 2m2-2 2 2"/></svg>
                  <p className="mb-2 text-sm"><span className="font-semibold">Click to upload</span> or drag and drop</p>
                  <p className="text-xs">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
              </div>
              <input id="dropzone-file" type="file" className="hidden" />
            </label>
        </div>
      </div>

      <div className='p-3 mb-3 border-b-2'>
        <p className='text-2xl font-semibold'>
          Title
        </p>

        <div>
          <label for="product-title">

            <div>
              <input id="product-title" type="text" className='w-full flex items-center justify-center text-body p-1 border-2'/>
            </div>

          </label>
          
        </div>
      </div>

      <div className='p-3 mb-3 border-b-2'>
        <p className='text-2xl font-semibold'>
          Category
        </p>

        <label htmlFor="product-category">

          <div>
            <select name="category" id="product-category" type="text" className='w-full flex items-center justify-center text-body p-1 border-2'>
              <option value="">Select a category</option>
              <option value="">Automotive</option>
              <option value="">Electronics</option>
              <option value="">Metallurgy</option>
              <option value="">Chemicals</option>
              <option value="">Medical Devices</option>
              <option value="">Food & Beverages</option>
            </select>
          </div>

        </label>
      </div>

      <div className='p-3 mb-3 border-b-2'>
        <p className='text-2xl font-semibold'>
          Product Specifications
        </p>

        <div>

          <div>
            <p>Materials</p>

            <div>
              <label for="product-materials">

                <div>
                  <input id="product-materials" type="text" className='w-full flex items-center justify-center text-body p-1 border-2'/>
                </div>

              </label>
              
            </div>

          </div>

          <div>
            <p>Length</p>

            <div>
              <label for="product-length">

                <div>
                  <input id="product-length" type="text" className='w-full flex items-center justify-center text-body p-1 border-2'/>
                </div>

              </label>
              
            </div>

          </div>

          <div>
            <p>Width</p>

            <div>
              <label for="product-width">

                <div>
                  <input id="product-width" type="text" className='w-full flex items-center justify-center text-body p-1 border-2'/>
                </div>

              </label>
              
            </div>

          </div>

          <div>
            <p>Height</p>

            <div>
              <label for="product-height">

                <div>
                  <input id="product-height" type="text" className='w-full flex items-center justify-center text-body p-1 border-2'/>
                </div>

              </label>
              
            </div>

          </div>

        </div>
      </div>

      <div className='p-3 mb-3 border-b-2'>
        <p className='text-2xl font-semibold'>
          Product Description
        </p>

        <div>
          <label for="product-desc">

            <div>
              <textarea id="product-desc" name='product-desc' className='w-full flex items-center justify-center text-body p-1 border-2'/>
            </div>

          </label>
          
        </div>
      </div>

      <div className='p-3 mb-3 border-b-2'>
        <p className='text-2xl font-semibold'>
          Pricing
        </p>

        <div>
          <label for="product-title">

            <div>
              <input id="product-title" type="text" className='w-full flex items-center justify-center text-body p-1 border-2'/>
            </div>

          </label>
          
        </div>
      </div>

      <div className='p-3 mb-3 border-b-2'>
        <p className='text-2xl font-semibold'>
          Shipping
        </p>

        <div>
          <label for="product-title">

            <div>
              <input id="product-title" type="text" className='w-full flex items-center justify-center text-body p-1 border-2'/>
            </div>

          </label>
          
        </div>
      </div>

      <div className='p-3 mb-3 border-b-2'>
        <button
          className="w-full bg-red-800 items-center rounded-xl px-6 py-3 text-white shadow hover:bg-rose-400 hover:text-white transition duration-200"
        >
          Create New Product
        </button>
      </div>

      


    </div>
  )
}

export default SupplierCreateNewProduct